$(function () {
    let $body = $('body');
    // Pagination - click on `...` to open it
    $body.on('click', '.pagination__dots', function () {
        $('.pagination__input-number').hide();
        $(this).find('.pagination__input-number').show();
        $('.goToPageNumber').focus();
    });

    // Pagination - submit goto page
    $body.on('submit', '.goToPageNumberClass', function () {
        let pageNo = $(this).find('.goToPageNumber').val();
        let url = `${location.href}?page=${pageNo}&`;
        if (location.href.match(/page=/)) {
            url = location.href.replace(/page=(\d*)/, `page=${pageNo}`);
        } else if (location.href.indexOf('?') !== -1) {
            url = location.href.replace(/(\?)/, `?page=${pageNo}&`);
        }

        url = url.replace(/&$/, '');
        location.href = url;

        return false;
    });
});
